import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AdminUtilService {
  private endpoint = environment.api + 'utils'

  constructor(private http: HttpClient) { }

  getFiles(token: string, type: string, prefix: string): Observable<any> {
    const url = `${this.endpoint}/s3/files?type=${type}&prefix=${prefix}`
    const h = new HttpHeaders({
      'Accept': 'application/json; charset=utf-8',
      'auth': token
    });
    return this.http.get<any>(url, { headers: h });
  }

  getSignedUrl(token: string, type: 'HABIL' | 'CHEF', key: string): Observable<any> {
    const url = `${this.endpoint}/s3/signed-url?type=${type}&key=${key}`
    const h = new HttpHeaders({
      'Accept': 'application/json; charset=utf-8',
      'auth': token
    });
    return this.http.get<any>(url, { headers: h });
  }
}
